import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { QuoteSessionQuery } from '@app/store/session/session.query';
import { Pet } from '@models/Pet';

@Component({
	selector: 'qe-remove-pet-modal',
	templateUrl: './remove-pet-modal.component.html',
	styleUrls: ['./remove-pet-modal.component.scss'],
})
export class RemovePetModalComponent {
	public pet?: Pet;

	constructor(
		public dialogRef: MatDialogRef<RemovePetModalComponent>,
		@Inject(MAT_DIALOG_DATA) public data: { petId: string },
		private readonly session: QuoteSessionQuery,
	) {
		this.pet = this.session.getPetById(this.data.petId);
	}

	public dismiss(): void {
		this.dialogRef.close();
	}
}
